export const TYPE_ROULOTTE = [
    { id: 0, description: 'Roulotte' },
    { id: 1, description: 'Caravane à sellette (Fifth-wheel)' },
    { id: 2, description: 'Roulotte hybride' },
    { id: 3, description: 'tente-roulotte' },
    { id: 4, description: 'Autocaravane Type A' },
    { id: 5, description: 'Autocaravane Type B' },
    { id: 6, description: 'Autocaravane Type C' },
    { id: 7, description: 'VR utilitaire sport' },
]

export const TYPE_CAMPING = [
    { id: 0, description: 'Amenage' },
    { id: 1, description: 'Excursion' },
    { id: 2, description: 'Rustique' },
]